var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificationid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 17,
    fill: "#008080"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_26457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 13.9168C9.50805 13.9168 7.08301 11.4918 7.08301 8.50016C7.08301 5.50854 9.50805 3.0835 12.4997 3.0835C15.4913 3.0835 17.9163 5.50854 17.9163 8.50016C17.9163 11.4918 15.4913 13.9168 12.4997 13.9168ZM13.0413 8.50016V5.79183H11.958V9.5835H15.208V8.50016H13.0413Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_649_26457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(6 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationid);
export default __webpack_public_path__ + "static/media/verificationid.c76cd1af4876d92bfa499c2c6968cc34.svg";
export { ForwardRef as ReactComponent };